import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./store/containers/AppContainer";
import { initializeApp } from "firebase/app";

import { Provider } from "react-redux";
import store from "./store/configureStore";
import { verifyAuth } from "./store/actions/authActions";

const firebaseConfig = {
  apiKey: "AIzaSyCV8Jid2f4kNljXXU57pZY2UwQi8Xt37TI",
  authDomain: "workers-rights-46c43.firebaseapp.com",
  databaseURL: "https://workers-rights-46c43.firebaseio.com",
  projectId: "workers-rights-46c43",
  storageBucket: "workers-rights-46c43.appspot.com",
  messagingSenderId: "644811155639",
  appId: "1:644811155639:web:52538cfe0bbe6d9d30c532",
  measurementId: "G-F58YYCVGK0",
};

// const firebaseConfig = {
//   apiKey: "AIzaSyDZy9O03SzwKgX6MJZTRUEfpLZUQ4QY8Mw",
//   authDomain: "workers-rights-clean.firebaseapp.com",
//   databaseURL: "https://workers-rights-clean-default-rtdb.firebaseio.com",
//   projectId: "workers-rights-clean",
//   storageBucket: "workers-rights-clean.appspot.com",
//   messagingSenderId: "1004908273020",
//   appId: "1:1004908273020:web:13e6480a9cb89a549a18f9",
//   measurementId: "G-1CDDZJNK5W",
// };

initializeApp(firebaseConfig);
store.dispatch(verifyAuth());

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
